<template>
  <div>
    <h5 class="mb-3">Pengaturan Campaign Donasi</h5>
    <div class="form-check mb-3">
      <input id="donation_enabled_modal" type="checkbox" class="form-check-input" v-model="form.is_enabled">
      <label for="donation_enabled_modal" class="form-check-label"><b>Aktifkan Donasi</b></label>
    </div>
    <div v-if="form.is_enabled">
      <div class="row">
        <div class="col-md-8 mb-2">
          <label>Judul Campaign</label>
          <input v-model="form.title" class="form-control" placeholder="Donasi Peduli Bencana">
        </div>
        <div class="col-md-4 mb-2">
          <label>Target (Rp, 0 = tanpa target)</label>
          <input v-model.number="form.target_amount" type="number" min="0" class="form-control">
        </div>
      </div>
      <label>Deskripsi / Pesan Campaign</label>
      <textarea v-model="form.description" class="form-control mb-2" rows="3"></textarea>
      <label>URL Cover Image (opsional)</label>
      <input v-model="form.cover_image_url" class="form-control mb-2" placeholder="https://...">
      <label>Nominal Preset (pisahkan koma, dalam Rupiah)</label>
      <input v-model="form.suggested_amounts_text" class="form-control mb-2" placeholder="10000,25000,50000,100000">
      <div class="row mb-2">
        <div class="col-md-4">
          <div class="form-check">
            <input id="show_wall_modal" type="checkbox" class="form-check-input" v-model="form.show_donor_wall">
            <label for="show_wall_modal" class="form-check-label">Tampilkan donor wall</label>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-check">
            <input id="show_prog_modal" type="checkbox" class="form-check-input" v-model="form.show_progress">
            <label for="show_prog_modal" class="form-check-label">Tampilkan progress bar</label>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-check">
            <input id="allow_anon_modal" type="checkbox" class="form-check-input" v-model="form.allow_anonymous">
            <label for="allow_anon_modal" class="form-check-label">Izinkan donasi anonim</label>
          </div>
        </div>
      </div>
    </div>
    <div class="text-right mt-3">
      <button class="btn btn-light mr-2" @click="$emit('close')">Batal</button>
      <button class="btn btn-primary" @click="save" :disabled="isSaving">
        <span v-if="isSaving" class="spinner-border spinner-border-sm mr-1"></span>
        Simpan
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DonationSettingsModal',
  props: {
    shopId: { type: Number, required: true },
  },
  data() {
    return {
      isSaving: false,
      form: {
        is_enabled: false,
        title: 'Donasi',
        description: '',
        target_amount: 0,
        cover_image_url: '',
        suggested_amounts_text: '10000,25000,50000,100000',
        show_donor_wall: true,
        show_progress: true,
        allow_anonymous: true,
      },
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      try {
        const r = await this.$store.dispatch('shop_donation/donation_get_settings', this.shopId);
        const s = r.data.data.settings;
        let amountsText = '10000,25000,50000,100000';
        if (s.suggested_amounts) {
          try {
            const arr = JSON.parse(s.suggested_amounts);
            if (Array.isArray(arr)) amountsText = arr.join(',');
          } catch (e) { /* noop */ }
        }
        this.form = {
          is_enabled: s.is_enabled === 1,
          title: s.title || 'Donasi',
          description: s.description || '',
          target_amount: s.target_amount || 0,
          cover_image_url: s.cover_image_url || '',
          suggested_amounts_text: amountsText,
          show_donor_wall: s.show_donor_wall !== 0,
          show_progress: s.show_progress !== 0,
          allow_anonymous: s.allow_anonymous !== 0,
        };
      } catch (e) { /* noop */ }
    },
    async save() {
      this.isSaving = true;
      try {
        const amounts = this.form.suggested_amounts_text
          .split(',').map(s => parseInt(s.trim(), 10)).filter(n => n > 0);
        const payload = {
          is_enabled: this.form.is_enabled ? 1 : 0,
          title: this.form.title,
          description: this.form.description || null,
          target_amount: this.form.target_amount || 0,
          cover_image_url: this.form.cover_image_url || null,
          suggested_amounts: JSON.stringify(amounts.length ? amounts : [10000, 25000, 50000, 100000]),
          show_donor_wall: this.form.show_donor_wall ? 1 : 0,
          show_progress: this.form.show_progress ? 1 : 0,
          allow_anonymous: this.form.allow_anonymous ? 1 : 0,
        };
        await this.$store.dispatch('shop_donation/donation_update_settings', { shopId: this.shopId, settings: payload });
        this.$toast.success('Pengaturan donasi tersimpan');
        this.$emit('saved');
        this.$emit('close');
      } catch (e) {
        this.$toast.error(e.response?.data?.message || 'Gagal simpan donasi');
      }
      this.isSaving = false;
    },
  },
};
</script>
